import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import image1 from '../../images/testimonial/1.png';
import image2 from '../../images/testimonial/2.png';
import image3 from '../../images/testimonial/3.png';
import image4 from '../../images/testimonial/4.png';
import image5 from '../../images/testimonial/5.png';
import image6 from '../../images/testimonial/6.png';

import Shape1 from "../../images/testimonial/star.svg";
import Shape2 from "../../images/testimonial/star-1.svg";
import Shape3 from "../../images/testimonial/quote.png";

const TestimonialData = [
    {
        id: "01",
        text: "We strive for excellence in every task, turning challenges into opportunities. Our commitment to quality drives us to deliver exceptional results.",
        subtitle: "Pursuing the Best, Always.",
        title: "Excellence",
        image: image1
    },
    {
        id: "02",
        text: "Creativity powers our problem-solving and helps us craft unique, future-ready solutions. It drives innovation and unlocks new possibilities",
        subtitle: " Innovate. Imagine. Inspire.",
        title: "Creativity",
        image: image2
    },
     {
        id: "03",
        text: "We deliver consistent, dependable results that clients can count on. Our reliability earns lasting trust and fuels our passion to perform.It ensures confidence in every project.",
        subtitle: "Trust Built on Consistency",
        title: " Reliability",
        image: image3
    },
     {
        id: "4",
        text: "Teamwork and open communication help us combine strengths and reach shared goals. Collaboration turns individual effort into collective success.",
        subtitle: "Together, We Achieve More.",
        title: "Collaboration",
        image: image4
    },
     {
        id: "05",
        text: "We offer maximum value at competitive prices without compromising on quality. Smart solutions ensure efficient use of every resource.",
        subtitle: "Value Driven, Budget Conscious.",
        title: " Cost Effective",
        image: image5
    },
    
    {
        id: "06",
        text: "We are dedicated to providing prompt and reliable assistance to our clients. Your needs guide our support every step of the way.Our goal is to ensure complete and consistent client satisfaction.",
        subtitle: "Here When You Need Us.",
        title: "Support",
        image: image6
    }
]



const TestimonialSection = () => {
    const ClickHandlar = () => {
        window.scrollTo(10, 0);
    }

    const settings = {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        infinite: true,
        responsive: [{
            breakpoint: 1199,
            settings: {
                dots: true,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                dots: true,
            }
        },

        ]
    };
    return (
        <section className="testimonial-section section-padding">
            <div className="container">
                <div className="row align-content-center">
                    <div className="col-xl-4 col-12">
                        <div className="section-title">
                            <span>Core Values</span>
                            <h2>Do the Right Thing, Always.</h2>
                            <p>We uphold honesty and strong moral principles in every decision and action.We stay flexible and open to change in a fast-paced, evolving environment. </p>
                            <div className="testimonial-btn">
                                <Link to="/Contact" className="theme-btn" onClick={ClickHandlar}> Get in Touch <i className="ti-arrow-right"></i></Link>
                                
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8 col-12">
                        <div className="testimonial-slider">
                            <Slider {...settings}>
                                {TestimonialData.map((Testimonials, tky) => (
                                    <div className="item" key={tky}>
                                        <div className="client">
                                            <div className="image">
                                                <img src={Testimonials.image} alt="" />
                                            </div>
                                            <div className="text">
                                                <h2>{Testimonials.title}</h2>
                                                <span>{Testimonials.subtitle}</span>
                                            </div>
                                        </div>
                                        <div className="reting">
                                            <ul>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape1} alt="" /></li>
                                                <li><img src={Shape2} alt="" /></li>
                                            </ul>
                                            <span>(4.0)</span>
                                        </div>
                                        <p>{Testimonials.text}</p>
                                        <div className="icon">
                                            <img src={Shape3} alt="" />
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TestimonialSection







